import { render } from "./contact-summary.vue?vue&type=template&id=273a3608&scoped=true"
import script from "./contact-summary.vue?vue&type=script&lang=js"
export * from "./contact-summary.vue?vue&type=script&lang=js"

import "./contact-summary.vue?vue&type=style&index=0&id=273a3608&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273a3608"]])

export default __exports__